import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectPackage {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectPackage = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectPackage) => {

  const itemList = useStoreState((state) => state.order.packageListByProductId);
  const onSelect = (id) => {
    if (itemList) {
      const val = itemList.find((item) => item.packageId === id);
      onChange(val);
    }
  };

  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected?.packageId}
      style={style}
      placeholder="Select Package"
      filterOption={(input, option) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.packageId} value={type.packageId}>
            {type.packageName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Packages</Option>
      )}
    </Select>
  );
};
